// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41848a0e","453":"c467cd43","455":"5d02a408","977":"8d4cde38"}[chunkId] + ".chunk.js";
};